import { useAtomValue } from 'jotai';

import { CaregiverRoleEnum } from '@/shared/enums';

import { caregiverRoleAtom } from '@/caregiverSpace/shared/model';

type UseCaregiverRoleFeaturesOptions = {
    isStandaloneNote?: boolean;
};

export const useCaregiverRoleFeatures = ({
    isStandaloneNote = false,
}: UseCaregiverRoleFeaturesOptions = {}) => {
    const caregiverRole = useAtomValue(caregiverRoleAtom);

    const showDiagnosisCode =
        caregiverRole !== CaregiverRoleEnum.Veterinarian &&
        caregiverRole !== CaregiverRoleEnum.Psychologist &&
        !isStandaloneNote;

    const showPhysioOutcome =
        caregiverRole === CaregiverRoleEnum.Physiotherapist &&
        !isStandaloneNote;

    const showReasonAndOutcome =
        caregiverRole === CaregiverRoleEnum.Veterinarian && !isStandaloneNote;

    return {
        caregiverRole,
        showDiagnosisCode,
        showPhysioOutcome,
        showReasonAndOutcome,
    };
};
